import { useState } from "react";
import { Modal } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import CroppieModal from "./croppie-modal";
import { hideLoader, showLoader } from "./loader";

let croppie_image = { url: "", id: null };
const EditLinkProfilePicUploadModal = ({ showprofilePicModal }) => {
    const [croppie, setCroppie] = useState(null);
    const [showCroppieModal, setshowCroppieModal] = useState(null);
    const { basePath } = useSelector(state => state?.slugReducer);
    const customizeProfileReducer = useSelector(state => state.customizeProfileReducer)
    const profilePicUploadReducer = useSelector(state => state.editlinkProfilePicUploadReducer);
    const editLinkModal = useSelector(state => state.editLinkModal)

    const dispatch = useDispatch();
    const history = useHistory();

    function generate_image_preview(input) {

        showLoader()
        if (input.files && input.files[0]) {
            let reader = new FileReader();
              alert(input.files[0].size);
            if (input.files[0].size >= 5242880) {
                toast.error('File Size Should not exceed 5MBs');
                return;
            }
            var val = input.files[0].name;
            // alert(val);
            var valid_extensions = ['png', 'jpg', 'jpeg'];
            var extension = val.substring(val.lastIndexOf('.') + 1, val.length) || val;
            if (!valid_extensions.includes(extension)) {
                toast.error('Invalid Image File. Should be png, jpg or jpeg');
                return;
            }
            
            setshowCroppieModal(true)
            setTimeout(() => {
                dispatch({ type: "RESET_EDITLINK_PROFILE_PIC_MODAL" });
                dispatch({ type: "RESET_PROFILE_PIC_MODAL" });
            }, 400);
            reader.onload = event => {
                croppie_image = {
                    url: event.target.result,
                };
                const el = document.getElementById("image_demo2");
                try {
                    
// console.log("el", el);
                    if (el) {
                        var croppieInstance = new Croppie(el, {
                            enableExif: true,
                            viewport: profilePicUploadReducer.to == "page-editor" ? {
                                width: 240,
                                height: 135,
                                type: 'square'
                            } : {
                                width: 250,
                                height: 250,
                                type: 'circle'
                            },
                            boundary: {
                                width: 300,
                                height: 300
                            }
                        });
                        croppieInstance.bind({
                            url: event.target.result,
                        }).then(function () {
                            
// console.log('jQuery bind complete');
                            setTimeout(() => {

                            }, 300);
                        }).catch(() => {
                            croppieClose()
                        })
                        setCroppie(croppieInstance)
                    }
                } catch { }

            };
            reader.readAsDataURL(input.files[0]);
        }
    };
    const dropzoneChange = (e) => {
        
// console.log("e.dataTransfer.files");
        
        showLoader()
        setTimeout(() => {
            generate_image_preview(e.target);
            hideLoader();
        }, [500])
    }
    const handleHide = () => {
        setshowCroppieModal(false);
        setCroppie(null)
        croppie_image = { url: "", id: null };
        history.push(basePath + "/page-editor")
    };
    const croppieClose = () => {
        showLoader()
        setshowCroppieModal(false);
        setCroppie(null)
        croppie_image = { url: "", id: null };
        setTimeout(() => {
            dispatch({ type: "SET_EDITLINK_PROFILE_PIC_MODAL", payload: { ...profilePicUploadReducer, show: true } });
            hideLoader();
        }, 400);
    };
    const croppedImage = () => {
        if (croppie !== null) {
            // return;
            croppie.result({
                type: "canvas",
                size: "original",
                format: "png",
                quality: 1,
                type: "blob"
            })
                .then((response) => {
                    
// console.log("editLinkModal", editLinkModal)
                    setshowCroppieModal(false)
                    dispatch({
                        type: "SET_EDIT_LINK_MODAL", payload: {
                            ...editLinkModal,
                            show: true,
                        }
                    });
                    dispatch({ type: "SET_UPLOAD_IMAGE", payload: { "editLink": response, "image_url": croppie?.data?.url } })

                })
        }
    };
    const handleCloseModal = () => {
        showLoader()
        dispatch({ type: "RESET_EDITLINK_PROFILE_PIC_MODAL" });
        setCroppie(null)
        croppie_image = { url: "", id: null };
        setTimeout(() => {
            // if (to == "customize") {
            //     history.goBack()
            // }
            // else
            history.push(basePath + "/page-editor")
            hideLoader();
        }, 400);

    };

    return (
        <>
            <Modal centered show={showprofilePicModal} onHide={handleHide} id="profile_pic_upload_modal">
                <div class="modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">

                        <div class="modal-header create-biolink-header">
                            <h5 class="modal-title create-biolink-heading">Upload Image</h5>
                            <button type="button" class="close" onClick={handleCloseModal} aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div class="modal-body">
                            <section class="mt-2 mb-2">
                                <form action="" method="POST" enctype="multipart/form-data">
                                    <div class="">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group mb-0">
                                                    <div class="preview-zone hidden">

                                                    </div>
                                                    <div class="dropzone-wrapper dropzone-wrapper1">
                                                        <div class="dropzone-desc">

                                                            <svg width="35" height="35" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <circle cx="22" cy="22" r="22" fill="#EBF5FF" />
                                                                <path d="M29.5962 15.8218C30.1104 16.077 30.5697 16.4394 30.9462 16.8852C31.5643 17.6169 31.9347 18.5424 31.9921 19.5294L32 19.8V28.6C32 30.9564 30.2318 32.8802 28.0096 32.9946L27.8 33H15.2C12.9507 33 11.1144 31.1476 11.0051 28.8196L11 28.6V19.8C11 18.7123 11.3795 17.6835 12.0538 16.8852C12.3675 16.5137 12.7387 16.2001 13.1513 15.9583L13.4038 15.8218L14.3027 17.8101C14.0457 17.9376 13.8154 18.1193 13.6265 18.343C13.331 18.6929 13.1495 19.1284 13.1088 19.5972L13.1 19.8V28.6C13.1 29.7598 13.9566 30.71 15.0432 30.794L15.2 30.8H27.8C28.9071 30.8 29.8141 29.9025 29.8942 28.7642L29.9 28.6V19.8C29.9 19.2546 29.7112 18.7429 29.3735 18.343C29.2224 18.1641 29.0447 18.012 28.8481 17.893L28.6973 17.8101L29.5962 15.8218ZM21.5 11L21.5203 11.0002L21.562 11.0019C21.5743 11.0027 21.5867 11.0037 21.599 11.0049L21.6225 11.0074L21.6506 11.0113C21.6714 11.0145 21.6922 11.0183 21.7129 11.0227C21.7222 11.0246 21.7315 11.0268 21.7408 11.0291L21.774 11.0379L21.8065 11.0477C21.8136 11.0499 21.8207 11.0523 21.8277 11.0547C21.8484 11.0617 21.8691 11.0696 21.8896 11.0782C21.9082 11.086 21.9264 11.0942 21.9444 11.103C21.9661 11.1137 21.9875 11.1252 22.0085 11.1374C22.0212 11.1447 22.034 11.1525 22.0467 11.1606C22.0521 11.1642 22.0575 11.1677 22.0629 11.1713L22.1178 11.2104C22.1264 11.217 22.1351 11.2238 22.1436 11.2307C22.152 11.2377 22.1543 11.2397 22.1567 11.2417L22.2424 11.3222L26.4424 15.7222C26.8525 16.1518 26.8525 16.8482 26.4424 17.2778C26.0639 17.6744 25.4683 17.7049 25.0564 17.3693L24.9576 17.2778L22.55 14.7565V27.5C22.55 28.1075 22.0799 28.6 21.5 28.6C20.9615 28.6 20.5177 28.1754 20.457 27.6283L20.45 27.5V14.7554L18.0424 17.2778C17.6324 17.7074 16.9676 17.7074 16.5576 17.2778C16.179 16.8813 16.1499 16.2573 16.4702 15.8258L16.5576 15.7222L20.7576 11.3222L20.8433 11.2417C20.8457 11.2397 20.848 11.2377 20.8504 11.2357L20.7576 11.3222C20.7969 11.281 20.8386 11.2437 20.8822 11.2104C20.9054 11.1928 20.929 11.1762 20.9533 11.1607C20.966 11.1525 20.9788 11.1446 20.9917 11.1371C21.0125 11.1252 21.0339 11.1137 21.0557 11.103C21.0736 11.0943 21.0918 11.086 21.1101 11.0784C21.1308 11.0697 21.1516 11.0617 21.1727 11.0545C21.1794 11.0523 21.1864 11.0499 21.1935 11.0477L21.2262 11.0378C21.2371 11.0347 21.2481 11.0318 21.2592 11.0291L21.2871 11.0227C21.3078 11.0183 21.3286 11.0145 21.3494 11.0113C21.3584 11.0099 21.3679 11.0086 21.3775 11.0074L21.401 11.0049C21.4133 11.0037 21.4257 11.0027 21.438 11.0019L21.4799 11.0002C21.4866 11.0001 21.4933 11 21.5 11Z" fill="#53A4F6" />
                                                            </svg>

                                                            <p class="mb-1"><strong>Drag and drop files, or <a style={{ color: "#53A4F6" }}>Browse</a></strong></p>
                                                            <small>5MB max file size upload</small>
                                                        </div>
                                                        <input type="file" accept=".png,.jpg,.jpeg" name="img_logo"
                                                            class="dropzone dropzone1" onChange={dropzoneChange} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </form>
                            </section>

                        </div>

                    </div>
                </div>
            </Modal>

            {/* <div className={showCroppieModal ? null : `d-none`}> */}
            <CroppieModal show={showCroppieModal} handleHide={handleHide} croppieClose={croppieClose} croppedImage={croppedImage} to={profilePicUploadReducer?.to} />
            {/* </div> */}
        </>
    )
}
export default EditLinkProfilePicUploadModal